<template>
  <div :class="[baseCss, verticalInternal ? `${baseCss}-vertical` : null, 'select-none', 'inline-block', makeLocation()]" :style="{zIndex}">
    <ul :class="[verticalInternal ? null : 'inline-list']">
      <li v-for="(service, index) in services" :key="index" :class="['p-0.5']" @click="popup(service.url(getLocation()), service)">
        <div :is="verticalInternal ? 'div' : 'table-layout'" y-align="middle" :class="[setTextColor(), vertical ? 'text-center' : null, 'overflow-hidden', fancy && !vertical && !rounded ? 'rounded-full' : null, rounded && !fancy ? 'rounded' : null, vertical && rounded ? ['rounded'] : null, `shadow-${elevation}`, 'cursor-pointer', `text-${fontSize}`, `bg-${makeClassName(service.label || service.icon)}-500`]">
          <div :is="verticalInternal ? 'div' : 'row'">
            <div :is="verticalInternal ? 'div' : 'cell'" x-align="center" :class="[fancy ? ['pl-2', 'pr-1'] : 'px-1', 'py-1', 'py-1', `${baseCss}-icon`, 'transition-all', 'duration-300', 'text-center']">
              <icon :size="iconSize" :color="color" :color-lightness="colorLightness" :name="service.icon" :icon-provider="iconProvider" />
            </div>
            <div :is="verticalInternal ? 'div' : 'cell'" x-align="center" v-html="service.label" v-if="service.label" :class="[fancy ? ['pr-2', 'pl-1'] : 'px-1', 'py-1', `${baseCss}-label`, uppercase ? 'uppercase' : null, bold ? 'font-semibold' : null, 'leading-tight']" />
          </div>
        </div>
        <brand-color :name="makeClassName(service.label || service.icon)" :hex="service.bgColor" />
      </li>
    </ul>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'SocialBar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      verticalInternal: false,
      baseCss: this.componentBaseCss('social-bar', [])
    }
  },
  props: {
    rounded: {
      type: Boolean,
      default: true
    },
    fancy: {
      type: Boolean
    },
    vertical: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'white'
    },
    colorLightness: {
      type: Number,
      default: null
    },
    iconSize: {
      type: Number,
      default: 1.5
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    bold: {
      type: Boolean,
      default: true
    },
    shareDefault: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    fontSize: {
      type: String,
      default: 'xs',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    },
    location: {
      type: String,
      default: 'inline',
      validator: value => {
        return ['inline', 'top', 'right', 'bottom', 'left'].includes(value)
      }
    },
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    popupWidth: {
      type: Number,
      default: 640
    },
    popupHeight: {
      type: Number,
      default: 480
    }
  },
  watch: {
    vertical () {
      this.setVerticalInternally()
    }
  },
  mounted () {
    this.setVerticalInternally()
  },
  methods: {
    popup (url = window.location.href, service) {
      const shareDefault = this.shareDefault
      const width = this.popupWidth
      const height = this.popupHeight
      this.$emit('share', service)
      if (shareDefault) {
        const left = (screen.width / 2) - (width / 2)
        const top = (screen.height / 2) - (height / 2)
        return window.open(url, `${this.baseCss}`, `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`)
      }
    },
    getLocation () {
      return location.href
    },
    makeClassName (label) {
      return `${this.baseCss}-${label}`.toLowerCase()
    },
    setVerticalInternally () {
      this.verticalInternal = this.vertical
    },
    makeLocation () {
      const location = this.location
      const locationClass = `${this.baseCss}-${location}`
      switch (location) {
        case 'inline':
          return [locationClass, 'static']
        case 'top':
          this.verticalInternal = false
          return [locationClass, 'fixed', 'left-0', 'top-1', 'w-full', 'text-center']
        case 'right':
          this.verticalInternal = true
          return [locationClass, 'fixed', 'right-1']
        case 'bottom':
          this.verticalInternal = false
          return [locationClass, 'fixed', 'left-0', 'bottom-1', 'w-full', 'text-center']
        case 'left':
          this.verticalInternal = true
          return [locationClass, 'fixed', 'left-1', 'top-50']
      }
    }
  }
}
</script>
<style>
.bcq-social-bar .bcq-social-bar-icon
{
  background: rgba(0, 0, 0, .25);
  width: 26px;
}

.bcq-social-bar li:hover .bcq-social-bar-icon
{
  background: rgba(0, 0, 0, 0);
}

.bcq-social-bar.bcq-social-bar-vertical .bcq-social-bar-icon
{
  width: 100%;
}

.bcq-social-bar.bcq-social-bar-right,
.bcq-social-bar.bcq-social-bar-left
{
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/social-bar/social-bar.vue